<template>
  <div>
    <Modal v-model="modal" title="Close Day" draggable>
      <Form>
        <FormItem label="End Reading">
          <Input v-model="endReading" type="number"/>
        </FormItem>
        <FormItem label="Price/Amount">
          <Input type="number" v-model="price"/>
        </FormItem>
      </Form>

      <div slot="footer">
        <Button type="primary" style="font-weight: bolder" @click="closeDay(tempoOrder.id)" :disabled="!endReading||!price" :loading="loader1">
          <span v-if="!loader1">Save</span>
          <span v-else>Loading...</span>
        </Button>
        <Button style="background: #999999; color: white;font-weight: bolder" @click="closeModal()">Cancel</Button>
      </div>
    </Modal>


            <div v-if="isRenderer" style="text-align: center;margin: 2px">
              <Button type="primary" @click="open" v-if="!$parent.$parent.$parent['tempoOrders'][pRow]['endReading']">Close</Button>
              <span v-else>Closed</span>
            </div>

  </div>
</template>

<script>
  import {BaseEditorComponent} from '@handsontable/vue'
  import {Constants} from "../../Constants/Constant"
  import {generate_UPDATE_ORDER_DATA} from "../../graphql/mutations/orders"

  export default {
    name: "ActionPopup",
    extends: BaseEditorComponent,
    data:function () {
      return{
        Constants: Constants,
        modal: false,
        tempoOrder: null,
        hotInstance: null,
        TD: null,
        row: null,
        col: null,
        prop: null,
        originalValue: null,
        value: '',
        cellProperties: null,
        isVisible: false,
        isEditor: null,
        isRenderer: null,
        editorElement: null,
        style: {
          position: "absolute",
          padding: "15px",
          background: "#fff",
          zIndex: 999,
          border: "1px solid #000",
          right: "0px",
          top: "0px"
        },
        loader1: false,
        endReading: '',
        price: ''
      }
    },
    computed:{
      pRow: function(){
        return this.hotInstance.toPhysicalRow(this.row)
      }
    },
    methods:{
      stopMousedownPropagation: function(e) {
        e.stopPropagation();
      },
      prepare: function(row, col, prop, td, originalValue, cellProperties) {
        BaseEditorComponent.options.methods.prepare.call(this, row, col, prop, td, originalValue, cellProperties);
        const tdPosition = td.getBoundingClientRect();
        this.style.right = (window.innerWidth - tdPosition.right) + 'px';
        this.style.top = tdPosition.top + window.pageYOffset + 'px';
      },
      open: function() {
        let pRow = this.hotInstance.toPhysicalRow(this.row)                             //When accessing original array
        this.tempoOrder = this.$parent.$parent.$parent['tempoOrders'][pRow]
        this.endReading = ''
        this.price = ''
        if(!this.tempoOrder.endReading){
          this.isVisible = true
          this.modal = true
        }
      },
      focus: function() {
        this.isVisible = true;
      },
      close: function() {
        this.isVisible = false;
      },
      setValue: function(value) {
        this.value = value;
      },
      getValue: function() {
        return this.value;
      },
      closeModal(){
        this.modal = false
      },
      closeDay(id){
        let obj = { endReading: this.endReading, price: this.price }
        this.updateRecord(id, obj, 'tempoOrders', 'loader1')
      },
      async updateRecord(id, obj, table, loaderStr){
        this[loaderStr] = true
        let response = await this.$apollo.mutate({
          mutation: generate_UPDATE_ORDER_DATA(table),
          variables: { id: id, obj: obj}
        })
        if(response.data){
          this.$Message.success('Tempo Order updated successfully!')
          this[loaderStr] = false
          this.close()
          this.closeModal()
          this.finishEditing()
        }
      },
    },
  }
</script>

<style scoped>
</style>
